( function () {
	'use strict';

	function CreateSchedCtrl ( logger, $modal ) {
		var self = this;

		function openModal () {
			$modal.open( {
				'templateUrl'  : '/templates/schedules/create-schedule/create-schedule-modal.html',
				'controller'   : 'CreateScheduleModalCtrl',
				'controllerAs' : 'vm',
				'keyboard'     : false,
				'backdrop'     : 'static',
				'resolve'      : {
					'dateModel' : function () {
						return self.date;
					}
				}
			} );
		}

		function activate () {
			logger.info( 'Activated Schedules View' );
		}

		activate();

		self.openModal = openModal;
	}

	angular
		.module( 'app.schedules' )
		.controller( 'CreateSchedCtrl', CreateSchedCtrl );

	CreateSchedCtrl.$inject = [ 'logger', '$modal' ];
} )( );
